import { IError } from "dto/IError";

/**
 * Komunikat błędu z odpowiedzi BE (`errorCodes`) albo z obiektu, który sam ma `errorCodes`.
 * Nigdy nie rzuca — wołający używają jej w `catch`/`onError`: odpowiedź bez `errorCodes` (429 z limitu żądań
 * `{ error, message }`, odpowiedź typu blob, błąd sieci) daje jej `message` albo pusty łańcuch.
 */
export const getErrorMessage = (error?: IError | unknown): string => {
  const source = error as { errorCodes?: unknown; response?: { data?: unknown } } | undefined;
  const data = source?.response?.data as { errorCodes?: unknown; message?: unknown } | undefined;
  const codes = source?.errorCodes ?? data?.errorCodes;

  if (Array.isArray(codes)) {
    return codes
      .map((x) => (x as { message?: unknown } | null)?.message)
      .filter((m): m is string => typeof m === "string" && m.length > 0)
      .join(", ");
  }

  return typeof data?.message === "string" ? data.message : "";
};
